export class DropdownOptionSerializer {
  static deserialize = option => (
    option && {
      displayName: option.dropdown_display_name,
      redirectTo: option.redirect_to,
    }
  );
}
